// ** Toolkit imports
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./auth/";

// ** redux persist
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// ** Reducers
import preferences from "./preferences";
import { api } from "@/api/api";
import enums from "@/store/enums";
import user from "@/store/user";
import flags from "@/store/flags";

import { rtkQueryErrorLogger } from "./auth/authMiddleware";
import pkg from "../../package.json";

const persistConfig = {
  key: `qualytest-${pkg.version}`,
  storage: storage,
  blacklist: [api.reducerPath, "auth"],
};

const rootReducer = combineReducers({
  user,
  preferences,
  enums,
  flags,
  auth: authReducer,
  [api.reducerPath]: api.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(api.middleware, rtkQueryErrorLogger),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export const persistor = persistStore(store);
